import { render, staticRenderFns } from "./blame_info.vue.js?vue&type=template&id=4dbd4d5b&scoped=true&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blame_info.vue?vue&type=template&id=4dbd4d5b&scoped=true&vue3"
import script from "./blame_info.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blame_info.vue?vue&type=script&lang=js&vue3"
export * from "./blame_info.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blame_info.vue?vue&type=script&lang=js&vue3"
import style0 from "./blame_info.vue.css?vue&type=style&index=0&id=4dbd4d5b&prod&scoped=true&lang=css&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blame_info.vue?vue&type=style&index=0&id=4dbd4d5b&prod&scoped=true&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd4d5b",
  null
  
)

export default component.exports